//
//
//
//
//
//
//

import copy from 'copy-to-clipboard'
import iconCopyToBoard from '@/assets/icon/itemDetail/gift_share_ic_copyToBoard_normal@2x.png'
import { getStaticShareUrl } from '@/tools/ObjectHelper'

export default {
  data () {
    return {
      iconCopyToBoard,
      shareUrl: ''
    }
  },
  props: {
    type: {
      type: String
    },
    title: {
      type: String
    },
    nickname: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 60
    },
    desc: {
      type: String,
      default: ''
    },
    image: {
      type: String,
      default: 'https://m.give543.com/static/ogimgsmall.jpg'
    },
    url: {
      type: String
    },
    objectId: {
      type: Number
    },
    query: {
      type: String,
      default: ''
    },
    showText: {
      type: Boolean,
      default: false
    },
    shareSuc: {
      type: Function
    }
  },
  mounted () {
    // // 獲取分享鏈接
    // configApi.getShareUrl({
    //   url: this.url,
    //   title: this.title,
    //   description: this.desc ? this.desc.replace(/(<([^>]+)>)/ig, '') : '',
    //   image: encodeURI(this.image)
    // }).then(res => {
    //   this.shareUrl = res.url
    // }).catch(err => {
    //   console.log(err)
    // })
  },
  methods: {
    onCopy () {
      this.$ga.trackEvent('copy_button', 'share', '')
      let infoText
      if (this.type === 'gift') {
        infoText = `${this.nickname}在贈物網分享了一則超棒的禮物，快點開看看！`
      } else if (this.type === 'need') {
        infoText = `${this.nickname}在贈物網發起了『${this.title}』的需求，一起來幫幫他吧！`
      } else if (this.type === 'story') {
        infoText = `推薦您贈物網上的好文：『${this.title}』`
      } else {
        infoText = this.title
      }

      let url = getStaticShareUrl(this.type, this.objectId, this.query) || this.url

      const success = copy(infoText + ' ' + url)
      if (success) {
        this.$vux.toast.text('複製成功')
        this.shareSuc && this.shareSuc()
      } else {
        this.$vux.toast.text('複製失敗，建議您手動複製')
      }
    }
  }
}
